<template>
    <ExtendedLayout
        :project="project"
        currentTab="feeds"
    >

        <Panel>

            <Heading type="h2" class="flex items-center gap-2">
                <InertiaLink :href="$route('admin::projects.feeds.index', { project: project.id })">
                    {{ __('admin::feeds.feeds') }}
                </InertiaLink>
                <ChevronRightIcon class="h-4 w-4 text-gray-600" />
                <span>{{ __('admin::general.create') }}</span>
            </Heading>

            <form @submit.prevent="submit">

                <FormGroup :label="__('admin::labels.name')" :error="errors.name">
                    <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.type')" :error="errors.type">
                    <Select name="type" :options="typeOptions" :has-error="exists(errors.type)" v-model="form.type" :required="true" :allow-empty="false" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.url')" :error="errors.url" v-if="form.type !== 'manual'">
                    <Input name="url" type="text" :has-error="exists(errors.url)" v-model="form.url" :required="true" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.status')" :error="errors.type" v-if="project.type === 'multi_feed'">
                    <Select name="status" :options="statusOptions" :has-error="exists(errors.status)" v-model="form.status" :required="false" :allow-empty="true" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.department')" :error="errors.department_id" v-if="project.type === 'multi_feed'">
                    <Select name="department_id" :options="departmentOptions" :has-error="exists(errors.department_id)" v-model="form.department_id" :required="false" :allow-empty="true" />
                </FormGroup>

                <div class="grid grid-cols-2 gap-4">
                    <FormGroup :label="__('admin::labels.latitude')" :error="errors.latitude">
                        <Input name="latitude" type="number" step="any" :has-error="exists(errors.latitude)" v-model="form.latitude" :required="false" />
                    </FormGroup>

                    <FormGroup :label="__('admin::labels.longitude')" :error="errors.longitude">
                        <Input name="longitude" type="number" step="any" :has-error="exists(errors.longitude)" v-model="form.longitude" :required="false" />
                    </FormGroup>
                </div>

                <Button :loading="form.processing">
                    {{ __('admin::general.create_model', {'model': __('admin::feeds.feed').toLowerCase() }) }}
                </Button>

            </form>

        </Panel>

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@/Pages/Projects/Edit';
import Panel from "@/Components/Panel";
import Button from "@/Components/Button";
import FormGroup from "@/Components/FormGroup";
import Input from "@/Components/Input";
import Heading from "@/Components/Heading";
import {ChevronRightIcon} from "@heroicons/vue/outline";
import Select from "@/Components/Select";

export default {
    components: {
        Select,
        ChevronRightIcon,
        Heading,
        Input,
        FormGroup,
        Button,
        Panel,
        ExtendedLayout,
    },
    props: {
        errors: Object,
        project: Object,
        typeOptions: Object,
        statusOptions: Object,
        departmentOptions: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                name: '',
                type: 'xml',
                url: null,
                status: '',
                department_id: '',
                latitude: '',
                longitude: '',
            })
        }
    },
    methods: {
        submit() {
            this.form
                .post(this.$route('admin::projects.feeds.store', { project: this.project.id }));
        }
    },
}
</script>
